/**
 * The two cost reports as their own screens (FSD 2.2.6): Absorption Variance and
 * Cost Object Profitability each answer a separate menu item, so each is a
 * route rather than a tab on a combined `/cost/reports` page. That combined
 * route is retired; the wave's INT packet redirects `/cost/reports` to the
 * absorption-variance screen and spreads this array into the route table.
 */

import type { RouteRecordRaw } from 'vue-router'

import { COST_PERMISSIONS } from '@/modules/cost/permissions'

export const COST_REPORT_ROUTES: RouteRecordRaw[] = [
  {
    path: '/cost/reports/absorption-variance',
    name: 'cost-absorption-variance',
    component: () => import('@/modules/cost/reports/AbsorptionVarianceView.vue'),
    meta: { titleKey: 'cost.routeTitles.absorptionVariance', permission: COST_PERMISSIONS.reportRead },
  },
  {
    path: '/cost/reports/profitability',
    name: 'cost-profitability',
    component: () => import('@/modules/cost/reports/ProfitabilityView.vue'),
    meta: { titleKey: 'cost.routeTitles.profitability', permission: COST_PERMISSIONS.reportRead },
  },
]
